import React                  from 'react';
import { ObjectSchema }       from 'yup';
import {
  Formik,
  FormikProps,
}                             from 'formik';
import { Breakpoint }         from '@material-ui/core/styles/createBreakpoints';
import {
  ILocation,
  ICarfaxReport,
  IInventoryContact,
}                             from '@typings/auction';
import { ICreditUnion }       from '@typings/accountManagement';
import {
  EBodyStyle,
  EConditionType,
  EAudience,
}                             from '@enums/auction';
import { AccountPageWrapper } from '../components/AccountPageWrapper';
import { AuctionDetailsForm } from '../components/AuctionDetailsForm';

interface IProps {
  push                : (path: string) => void;
  width               : Breakpoint;
  inventoryContacts   : IInventoryContact[];
  locations           : ILocation[];
  currentAccount      : ICreditUnion;
  initialValues       : IVehicleInfoValues;
  validationSchema    : ObjectSchema;
  onInputVinCode      : (event: React.ChangeEvent<HTMLInputElement>) => void;
  formikRef           : React.MutableRefObject<FormikProps<IVehicleInfoValues> | null>;
  handleUpdateAuction : (values: IVehicleInfoValues) => void;
  isLoadingUpdate     : boolean;
  carfaxReport?       : ICarfaxReport;
}

export interface IVehicleInfoValues {
  vin                          : string;
  vehicleBodyStyle             : EBodyStyle;
  year                         : number;
  carBrandName                 : string;
  carModelName                 : string;
  miles                        : number;
  vehicleDescription           : string;
  featuresAndEquipment         : string;
  fullDisclosure               : string;
  exteriorCondition            : EConditionType;
  interiorCondition            : EConditionType;
  mechanicalCondition          : EConditionType;
  locationId                   : string;
  inventoryContactId           : string;
  minimumBid                   : number;
  bidIncrement                 : number;
  retailValue                  : number;
  wholesaleValue               : number;
  paymentTerms                 : string;
  includeSpecialFinancingOffer : boolean;
  specialFinancingOffer        : string;
  startDateAndTime             : string;
  endDateAndTime               : string;
  audience                     : EAudience;
}

export const AuctionDetailsPage: React.FC<IProps> = ({
  push,
  width,
  inventoryContacts,
  locations,
  currentAccount,
  initialValues,
  validationSchema,
  onInputVinCode,
  formikRef,
  handleUpdateAuction,
  isLoadingUpdate,
  carfaxReport,
}) => (
  <AccountPageWrapper
    push   = {push}
    cuInfo = {currentAccount}
    isWhite
  >
    <Formik
      innerRef         = {formikRef}
      onSubmit         = {handleUpdateAuction}
      initialValues    = {initialValues}
      validationSchema = {validationSchema}
      enableReinitialize
    >
      {({
        dirty,
        values,
        errors,
        touched,
        isValid,
        isSubmitting,
      }: FormikProps<IVehicleInfoValues>): JSX.Element => (
        <AuctionDetailsForm
          width             = {width}
          dirty             = {dirty}
          values            = {values}
          touched           = {touched}
          errors            = {errors}
          isValid           = {isValid}
          isSubmitting      = {isSubmitting}
          inventoryContacts = {inventoryContacts}
          locations         = {locations}
          onInputVinCode    = {onInputVinCode}
          isLoadingUpdate   = {isLoadingUpdate}
          carfaxReport      = {carfaxReport}
        />
      )}
    </Formik>
  </AccountPageWrapper>
);
